import { ActionType, getType } from 'typesafe-actions';

import {
  RevalueTradesMetricsSuccessPayload,
  TaskProgressSuccessPayload,
} from '../types';

import * as revaluationToolActions from './actions';

type RevaluationToolActionType = ActionType<typeof revaluationToolActions>;

export type RevaluationToolState = {
  valuesTaskProgress: {
    data: TaskProgressSuccessPayload;
    loading: boolean;
  };
  cvaTaskProgress: {
    data: TaskProgressSuccessPayload;
    loading: boolean;
  };
  revalueTrades: {
    data: RevalueTradesMetricsSuccessPayload;
    loading: boolean;
  };
  revalueCVA: {
    data: RevalueTradesMetricsSuccessPayload;
    loading: boolean;
  };
};

const initialState: RevaluationToolState = {
  valuesTaskProgress: {
    data: {
      current_count: 0,
      total_count: 0,
      status: '',
      state: '',
      statistic: {
        created_at: '',
        finished_at: '',
        duration: '',
      },
    },
    loading: false,
  },
  cvaTaskProgress: {
    data: {
      current_count: 0,
      total_count: 0,
      status: '',
      state: '',
      statistic: {
        created_at: '',
        finished_at: '',
        duration: '',
      },
    },
    loading: false,
  },
  revalueTrades: {
    data: {
      // task_id: null,
    },
    loading: false,
  },
  revalueCVA: {
    data: {
      // task_id: null,
    },
    loading: false,
  },
};

const revaluationToolReducer = (
  state: RevaluationToolState = initialState,
  action: RevaluationToolActionType,
): RevaluationToolState => {
  switch (action.type) {
    // value metrics task progress
    case getType(revaluationToolActions.getValueTaskProgress.request):
      return {
        ...state,
        valuesTaskProgress: {
          ...state.valuesTaskProgress,
          loading: true,
        },
      };
    case getType(revaluationToolActions.getValueTaskProgress.success):
      return {
        ...state,
        valuesTaskProgress: {
          ...state.valuesTaskProgress,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(revaluationToolActions.getValueTaskProgress.failure):
      return {
        ...state,
        valuesTaskProgress: {
          ...state.valuesTaskProgress,
          loading: false,
        },
      };

    // cva task progress
    case getType(revaluationToolActions.getCVATaskProgress.request):
      return {
        ...state,
        cvaTaskProgress: {
          ...state.cvaTaskProgress,
          loading: true,
        },
      };
    case getType(revaluationToolActions.getCVATaskProgress.success):
      return {
        ...state,
        cvaTaskProgress: {
          ...state.cvaTaskProgress,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(revaluationToolActions.getCVATaskProgress.failure):
      return {
        ...state,
        cvaTaskProgress: {
          ...state.cvaTaskProgress,
          loading: false,
        },
      };

    // value metrics revaluation
    case getType(revaluationToolActions.revalueTrades.request):
      return {
        ...state,
        revalueTrades: {
          ...state.revalueTrades,
          loading: true,
        },
      };
    case getType(revaluationToolActions.revalueTrades.success):
      return {
        ...state,
        revalueTrades: {
          ...state.revalueTrades,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(revaluationToolActions.revalueTrades.failure):
      return {
        ...state,
        revalueTrades: {
          ...state.revalueTrades,
          loading: false,
        },
      };

    // cva
    case getType(revaluationToolActions.revalueCVA.request):
      return {
        ...state,
        revalueCVA: {
          ...state.revalueCVA,
          loading: true,
        },
      };
    case getType(revaluationToolActions.revalueCVA.success):
      return {
        ...state,
        revalueCVA: {
          ...state.revalueCVA,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(revaluationToolActions.revalueCVA.failure):
      return {
        ...state,
        revalueCVA: {
          ...state.revalueCVA,
          loading: false,
        },
      };

    //reset valuation/cva task progress state
    case getType(revaluationToolActions.reset):
      return {
        ...state,
        valuesTaskProgress: initialState.valuesTaskProgress,
        revalueTrades: initialState.revalueTrades,
        cvaTaskProgress: initialState.cvaTaskProgress,
        revalueCVA: initialState.revalueCVA,
      };
    default:
      return state;
  }
};

export default revaluationToolReducer;
